<div class="contents">
    <label class="block text-sm font-medium mb-1">{{ label }}
        <span class="text-rose-500">
            {{ esRequerido() ? '*' : '' }}
        </span>
    </label>

    <div class="relative">
        <ckeditor [editor]="Editor" [(ngModel)]="editorData" [config]="editorConfig" (change)="onEditorChange($event)"
            (blur)="onEditorBlur()"></ckeditor>
    </div>
</div>